<template>
  <div class="web-legislacoes">
    <header class="header">
      <div class="center">
        <div class="logos">
          <div class="logo-ta-na-lei">
            <router-link :to="{ name: 'IndexLegislacao' }">
              <img
                src="../../assets/images/logo_horizontal_branco.png"
                class="logo-tanalei2"
                alt="Logo do Tá na Lei"
                title="Logo do Projeto Tá na Lei"
              />
            </router-link>
          </div>
        </div>
        <div class="botao">
          <router-link :to="{ name: 'Sobre' }">Sobre o Tá Na Lei</router-link>
        </div>
        <form @submit="buscar" method="GET" class="pesquisa">
          <span>
            <input
              type="text"
              v-model="termoBusca"
              id="pesquisar-legislacao"
              placeholder="Digite algo para pesquisar"
            />
            <button type="submit" for="pesquisar-legislacao">
              <img
                src="../../assets/images/icon_lupa.svg"
                class="logo-tanalei"
                alt="Logo do Tá na Lei"
              />
            </button>
          </span>
        </form>
      </div>
      <div class="linha"></div>
    </header>
    <div class="center centro">
      <div class="paginalegislacao">
        <div class="column-right">
          <div class="marcas-de-celulares">
            <p>Disponível para</p>
            <div class="icones-cel">
              <a
                target="_blank"
                href="https://apps.apple.com/br/app/t%C3%A1-na-lei/id1522888504?l=pt-br"
              >
                <img
                  src="../../assets/images/logo_apple_verde.png"
                  class="logo-apple"
                  alt="logo da apple"
                />
              </a>
              <a
                target="_blank"
                href="https://play.google.com/store/apps/details?id=br.gov.go.casacivil.tanalei"
              >
                <img
                  src="../../assets/images/logo_android_verde.png"
                  class="logo-android"
                  alt="logo do android"
                />
              </a>
            </div>
          </div>
          <div class="texto">
            <p>
              Baixe o
              <strong>app</strong>
              <br />e fique por
              <br />dentro dos
              <br />seus
              <strong>direitos</strong>!
            </p>
          </div>
          <img
            src="../../assets/images/mao_segurando_celular_sem_logo.png"
            class="celular"
            alt="imaem de uma mão segurando o celular com o aplicativo Ta Na Lei"
          />
          <!--
          <img
            src="../../assets/images/nova-logo-color.svg"
            class="logo-casa"
            alt="Logo da Casa Civíl"
          />
          -->
          
        </div>
        <div class="column-left">
          <template v-if="!carregandoTudo">
            <input id="atv-menu" type="checkbox" />
            <label for="atv-menu">
              <div class="menu">
                <span class="hamburger"></span>
              </div>
            </label>
            <!-- <div class="busca" v-if="categorias.length > 0">
              <div class="hover">
                <h3>Categorias</h3>
                <div class="caixa-menu">
                  <router-link
                    :to="{ name: 'IndexLegislacao', query: {} }"
                    class="categorias"
                    id="cat_todas"
                    @click.native="fecharMenu"
                  >Todas as Categorias</router-link>
                  <template v-for="categoria in categorias">
                    <router-link
                      @click.native="fecharMenu"
                      :key="categoria.id"
                      :to="{
                      name: 'IndexLegislacao',
                      query: { categoria_legislacao_selecionada_id: categoria.id },
                    }"
                    >{{ categoria.nome }}</router-link>
                  </template>
                </div>
              </div>
            </div> -->

            <div class="botoes">
              <div class="botao">
                <router-link :to="{ name: 'Sobre' }">Sobre o Tá Na Lei</router-link>
              </div>
              <div class="botao">
                <a
                  href="https://legisla.casacivil.go.gov.br/pesquisa_legislacao"
                  title="Legislação Completa"
                  target="blank"
                >Legislação Completa</a>
              </div>
            </div>
          </template>
          <div class="caixa-cads aviso-legislacao">
            <div style="text-align: center; padding: 40px 20px;">
              <p style="color: #d32f2f; font-weight: bold; font-size: 18px; margin: 0 0 15px 0;">
                ⚠️ ATENÇÃO
              </p>
              <p style="color: #333; font-size: 16px; line-height: 1.6; margin: 0;">
                Esta página está temporariamente suspensa, em atendimento à Lei Federal Nº 9.504/1997.
              </p>
            </div>
          </div>
          <!-- <div v-if="carregandoTudo">
            <clip-loader></clip-loader>
          </div> -->
<!-- 
          <div class="caixa-cads" v-else>
            <div v-if="carregandoLegislacoes">
              <clip-loader class="loader"></clip-loader>
            </div>
            <p
              class="sem-resultados"
              v-if="
                !carregandoLegislacoes &&
                  legislacoes.length <= 0 &&
                  !erroCarregarLegislacoes
              "
            >Nenhuma legislação encontrada!</p>
            <p
              v-if="erroCarregarLegislacoes"
              class="sem-resultados"
            >Houve um erro ao carregar os dados. Por favor, recarregue a página.</p>
            <template
              v-if="
                !carregandoLegislacoes &&
                  legislacoes.length > 0 &&
                  !erroCarregarLegislacoes
              "
            >
              <ul class="cads-leis">
                <li v-for="lei in legislacoes" :key="lei.id">
                  <router-link
                    :to="{
                      name: 'exibirLegislacao',
                      params: {
                        id: lei.id,
                      },
                      query: $route.query,
                    }"
                  >
                    <card-legislacao :lei="lei"></card-legislacao>
                  </router-link>
                </li>
              </ul>
              <div class="paginacao">
                <paginate
                  v-model="pagina"
                  :page-count="totalPaginas"
                  :click-handler="onPageClick"
                  :prev-text="'Anterior'"
                  :next-text="'Próxima'"
                  container-class="paginacao-container-interno"
                  disabled-class="link-pagination-disabled"
                ></paginate>
              </div>
            </template>
          </div> -->
        </div>
      </div>

      <router-view></router-view>
    </div>
    <footer>
      <div class="center">
        <!-- <img
          src="../../assets/images/logo_casa_bco.svg"
          class="logo-casa"
          alt="Logo do Tá na Lei"
          title="Logo do Projeto Tá na Lei"
        /> -->
      </div>
    </footer>
  </div>
</template>

<script>
// import ClipLoader from "vue-spinner/src/ClipLoader.vue";
// import Paginate from "vuejs-paginate";

import LegislacaoApi from "../../services/LegislacaoApi";
import CategoriaLegislacaoApi from "../../services/CategoriaLegislacaoApi";
// import CardLegislacao from "../../components/CardLegislacao.vue";

import SmartBanner from 'smart-app-banner'
import 'smart-app-banner/dist/smart-app-banner.css'

export default {
  name: "LegislacoesIndexView",
  metaInfo() {
    return {
      title: "Tá na Lei",
      titleTemplate: "%s - Casa Civil do Estado de Goiás",
      meta: [                                                                                                         
        {
          vmid: "description",
          name: "description",
          property: "description",
          content: "Fique por dentro dos seus direitos"
        },
        {
          vmid: "og:description",
          property: "og:description",
          content: "Fique por dentro dos seus direitos"
        },
        {
          vmid: "og:title",
          property: "og:title",
          content: "Tá na Lei - Casa Civil do Estado de Goiás"
        },
        {
          vmid: "og:url",
          property: "og:url",
          content: `${process.env.VUE_APP_BASE_URL}${this.$route.fullPath}`
        },
        {
          vmid: "og:type",
          property: "og:type",
          content: "article"
        },
        {
          vmid: "og:image",
          property: "og:image",
          content: process.env.VUE_APP_BASE_URL + "/tanalei_card.jpg"
        },
        {
          vmid: "og:image:secure_url",
          property: "og:image:secure_url",
          content: process.env.VUE_APP_BASE_URL + "/tanalei_card.jpg"
        },
        {
          vmid: "og:image:type",
          property: "og:image:type",
          content: "image/jpeg"
        },
        {
          vmid: "twitter:image",
          name: "twitter:image",
          property: "twitter:image",
          content: process.env.VUE_APP_BASE_URL + "/tanalei_card.jpg"
        },
        {
          vmid: "twitter:description",
          name: "twitter:description",
          property: "twitter:description",
          content: "Fique por dentro dos seus direitos"
        },
        {
          vmid: "twitter:title",
          name: "twitter:title",
          property: "twitter:title",
          content: "Tá na Lei - Casa Civil do Estado de Goiás"
        },
        {
          vmid: "twitter:site",
          name: "twitter:site",
          content: `${process.env.VUE_APP_BASE_URL}${this.$route.fullPath}`
        },
        {
          vmid: "twitter:card",
          name: "twitter:card",
          property: "twitter:card",
          content: "summary_large_image"
        },
        {
          vmid: "og:image:width",
          property: "og:image:width",
          content: "1201"
        },
        {
          vmid: "og:image:height",
          property: "og:image:height",
          content: "631"
        }
      ]
    };
  },
  data: function() {
    return {
      legislacoes: [],
      categorias: [],
      carregandoLegislacoes: true,
      erroCarregarLegislacoes: false,
      pagina:
        this.$route.query && this.$route.query.page
          ? parseInt(this.$route.query.page)
          : 1,
      categoriaId:
        this.$route.query && this.$route.query.categoria_legislacao_selecionada_id
          ? parseInt(this.$route.query.categoria_legislacao_selecionada_id)
          : null,
      totalPaginas: 0,
      termoBusca: this.$route.query && this.$route.query.termo
    };
  },
  components: {
    // paginate: Paginate,
    // ClipLoader,
    // CardLegislacao
  },
  created() {
    this.carregarLegislacao();
    new SmartBanner({
      daysHidden: 1,   // days to hide banner after close button is clicked (defaults to 15)
      daysReminder: 1, // days to hide banner after "VIEW" button is clicked (defaults to 90)
      appStoreLanguage: 'pt',
      title: 'Baixe agora o app',
      author: 'Secretaria da Casa Civil <br> Estado de Goiás',
      button: 'Baixar',
      store: {
        ios: 'Na App Store',
        android: 'Na Google Play'
      },
      price: {
        ios: 'Gratuito',
        android: 'Gratuito'
      },  
      icon: `${process.env.VUE_APP_BASE_URL}/icone_banner.png` // full path to icon image if not using website icon image
      // , theme: '' // put platform type ('ios', 'android', etc.) here to force single theme on all device
    })    
  },
  watch: {
    // call again the method if the route changes
    $route: function(to, from) {
      this.fecharMenu();
      const informacaoCarregada =
        this.legislacoes.length > 0 &&
        this.categorias.length > 0 &&
        !this.erroCarregarLegislacoes;

      const mudouQuery =
        to.query.categoria_legislacao_selecionada_id !== from.query.categoria_legislacao_selecionada_id ||
        from.query.page != to.query.page ||
        to.query.termo_busca != from.query.termo_busca;

      if (!informacaoCarregada || mudouQuery) {
        this.carregarLegislacao();
      }
    }
  },
  methods: {
    carregarLegislacao: async function() {
      try {
        this.erroCarregarLegislacoes = false;
        this.carregandoLegislacoes = true;
        let categorias;
        if (this.categorias.length == 0) {
          const { data } = await CategoriaLegislacaoApi.getCategorias();
          categorias = data;
        }
        this.pagina =
          this.$route.query && this.$route.query.page
            ? parseInt(this.$route.query.page)
            : 1;
        this.categoriaId =
          this.$route.query && this.$route.query.categoria_legislacao_selecionada_id
            ? parseInt(this.$route.query.categoria_legislacao_selecionada_id)
            : null;
        this.termoBusca = this.$route.query && this.$route.query.termo_busca;
        const { data } = await LegislacaoApi.getLegislacoes({
          page: this.pagina,
          categoriaId: this.categoriaId,
          termoBusca: this.termoBusca
        });
        if (categorias) {
          this.categorias = categorias;
        }
        this.legislacoes = data.resultados;
        this.totalPaginas = data.total_paginas;
        this.carregandoLegislacoes = false;
      } catch (err) {
        console.log(err, err.response);
        this.carregandoLegislacoes = false;
        this.erroCarregarLegislacoes = true;
      }
    },
    onPageClick: function(page) {
      this.pagina = page;
      this.termoBusca = this.$route.query && this.$route.query.termo_busca;
      this.categoriaId = this.$route.query && this.$route.query.categoria_legislacao_selecionada_id;
      this.$router.push({
        name: "IndexLegislacao",
        query: { page, termo_busca: this.termoBusca, categoria_legislacao_selecionada_id: this.categoriaId }
      });
    },
    buscar: function(event) {
      event.preventDefault();
      const termoBusca = this.$route.query && this.$route.query.termo_busca;
      if (this.termoBusca !== termoBusca || this.pagina != 1) {
        this.$router.push({
          name: "IndexLegislacao",
          query: {
            termo_busca: this.termoBusca
          }
        });
      } else {
        this.carregarLegislacao();
      }
    },
    fecharMenu: function() {
      const menu = document.getElementById("atv-menu");
      if (menu && menu.checked) {
        menu.click();
      }
    }
  },
  computed: {
    carregandoTudo: function() {
      return this.categorias.length == 0 && this.carregandoLegislacoes;
    }
  }
};
</script>
